<template>
    <div>
        <div class="mx-auto max-w-7xl md:px-8 xl:px-12">
            <div class="p-5 mb-8 space-y-8 bg-white divide-y divide-gray-200 rounded shadow-md sm:p-8 lg:p-12 sm:space-y-5">
                <div v-if="Object.entries(errors).length !== 0" class="notification is-danger">
                    <p>
                        <span class="icon">
                            <i class="icon-warning-sign"></i>
                        </span>
                        Oops, there were some problems updating this profile.
                    </p>
                    <div v-for="(index, error) in errors"
                        :key="error"
                        >
                        <br />&nbsp; <i class="fa fa-caret-right"></i> {{ index[0] }}
                    </div>
                </div>
                <div class="space-y-6 sm:space-y-5">
                    <div>
                        <h3 class="font-medium leading-5 text-gray-900 text-md">
                            {{manufacturer.company_name}}
                        </h3>
                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="company_name" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            Company Name*
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div class="flex max-w-lg rounded-md shadow-sm">
                                <input required type="text" name="company_name" id="company_name" v-model="manufacturer.company_name"
                                class="flex-1 block w-full min-w-0 border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                            </div>
                        </div>
                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="address" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            Address
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div class="flex max-w-lg rounded-md shadow-sm">
                                <input type="text" name="address" id="address" v-model="manufacturer.address"
                                class="flex-1 block w-full min-w-0 border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                            </div>
                        </div>
                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="address_2" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            Apt/Suite
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div class="flex max-w-lg rounded-md shadow-sm">
                                <input type="text" name="address_2" id="address_2" v-model="manufacturer.address_2"
                                class="flex-1 block w-full min-w-0 border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                            </div>
                        </div>
                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="city" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            City
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div class="flex max-w-lg rounded-md shadow-sm">
                                <input type="text" name="city" id="city" v-model="manufacturer.city"
                                class="flex-1 block w-full min-w-0 border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                            </div>
                        </div>
                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="state" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            State
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div class="flex max-w-lg rounded-md shadow-sm">
                                <input type="text" name="state" id="state" v-model="manufacturer.state"
                                class="flex-1 block w-full min-w-0 border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                            </div>
                        </div>
                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="zip" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            Zip
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div class="flex max-w-lg rounded-md shadow-sm">
                                <input type="text" name="zip" id="zip" v-model="manufacturer.zip"
                                class="flex-1 block w-full min-w-0 border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                            </div>
                        </div>
                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="phone" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            Phone
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div class="flex max-w-lg rounded-md shadow-sm">
                                <input type="text" name="phone" id="phone" v-model="manufacturer.phone"
                                class="flex-1 block w-full min-w-0 border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                            </div>
                        </div>
                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="website" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            Website
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div class="flex max-w-lg rounded-md shadow-sm">
                                <input type="text" name="website" id="website" v-model="manufacturer.website"
                                class="flex-1 block w-full min-w-0 border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                            </div>
                        </div>
                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="bio" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            Bio
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div class="flex max-w-lg rounded-md shadow-sm">
                                <textarea name="bio" id="" cols="30" rows="4" v-model="manufacturer.bio" class="block w-full max-w-lg border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="revenue_estimate" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            Revenue Estimate
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div class="flex max-w-lg rounded-md shadow-sm">
                                <input type="text" name="revenue_estimate" id="revenue_estimate" v-model="manufacturer.revenue_estimate"
                                class="flex-1 block w-full min-w-0 border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                            </div>
                        </div>
                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="est_number_employees" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            Est. Number of Employees
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div class="flex max-w-lg rounded-md shadow-sm">
                                <input type="text" name="est_number_employees" id="est_number_employees" v-model="manufacturer.est_number_employees"
                                class="flex-1 block w-full min-w-0 border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                            </div>
                        </div>
                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="specialties" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            Specialties
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div class="flex max-w-lg rounded-md shadow-sm">
                                <v-select
                                multiple
                                :options="specialties"
                                v-model="specValues"
                                class="flex-1 block w-full min-w-0 border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                :close-on-select="false"
                                :select-on-tab="true"
                                placeholder="Search Specialties..."
                                @input="(selection) => searchableSpecChange(selection)"
                                >
                                    <template #option="{label, category}">
                                        <span class="inline-flex">
                                            <p class="text-xs font-medium">{{ label }}</p><p class="ml-2 text-xs">- {{ category }}</p>
                                        </span>
                                    </template>
                                </v-select>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pt-5">
                <div class="flex items-center justify-between pt-5">
                    <a href="#" data-target="#modal-ajax"
                        :data-url="route('manufacturers.delete.modal', {'id': manufacturer.id})"
                        class="ajax-modal-button tw-button-red">Delete</a>
                    <div class="flex items-center justify-end">
                        <button @click="onCancel" class="mr-4 tw-simple-button">Cancel</button>
                        <button @click="onUpdate" class="tw-button-green">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        manufacturer: {
            type: [Array, Object],
            required: true,
        },
        specialties: {
            type: [Array, Object],
            require: true,
        },
        linkedSpecialties: {
            type: [Array, Object],
            required: true,
        }
    },
    data () {
        return {
            value: '',
            errors: {},
            success: false,
            specValues: this.linkedSpecialties
        };
    },
    computed: {
        // made to onUpdate method
        clearRequest: function () {
            const request = this.manufacturer;

            return request;
        }
    },
    watch: {
        destination: function () {
            this.saveSpecialties(this.manufacturer.specialties.concat(this.destination));
        },
    },
    created() {
        this.setSelectedFields();
    },
    methods: {
        setSelectedFields() {
            this.manufacturer.linked_specialties = this.specValues;
        },
        searchableSpecChange(selection) {
            this.specValues = selection;
        },
        selectableOption(option) {
            if (option in this.manufacturer.linked_specialties) {
                return false;
            }
            return true;
        },
        onUpdate () {
            this.manufacturer.specialties = this.specValues;
            axios.put(this.route('manufacturers.update',
                { manufacturer: this.manufacturer.id }), this.clearRequest)
                .then(res => {
                    if (this.errors) {
                        this.errors = false;
                    }
                    const params = encodeURIComponent(JSON.stringify(res.data));
                    window.location = this.route('manufacturers.show',
                        { manufacturer: this.manufacturer.id, success: params });
                })
                .catch(error => {
                    if (this.success) {
                        this.success = false;
                    }

                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                    } else if (error.response.status === 500) {
                        this.errors = Array(['Oops somethings went wrong!']);
                    }
                });
        },
        onCancel () {
            window.location = this.route('manufacturers.show', { manufacturer: this.manufacturer.id });
        },
    },
};
</script>

